<template>
  <div class="tags-view">
    <el-tag
      v-for="tag in visitedViews"
      :key="tag.path"
      :closable="tag.path !== '/dashboard'"
      :effect="isActive(tag) ? 'dark' : 'plain'"
      type="primary"
      class="tag-item"
      @click="go(tag)"
      @close="close(tag)"
    >{{ tag.title }}</el-tag>
    <el-dropdown class="more" @command="onCommand">
      <el-button type="text" icon="el-icon-arrow-down">标签</el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="refresh">刷新当前</el-dropdown-item>
        <el-dropdown-item command="others">关闭其他</el-dropdown-item>
        <el-dropdown-item command="all">关闭全部</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TagsView',
  computed: {
    ...mapGetters(['visitedViews'])
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (from && from.meta && from.meta.noTag) {
          this.$store.commit('tagsView/DEL_VIEW', { path: from.path })
        }
        if (!to.name || (to.meta && to.meta.noTag)) return
        this.$store.commit('tagsView/ADD_VIEW', to)
      }
    }
  },
  methods: {
    isActive(tag) { return tag.path === this.$route.path },
    safePush(location) {
      this.$router.push(location).catch(() => {})
    },
    go(tag) { this.safePush(tag.fullPath || tag.path) },
    close(tag) {
      this.$store.commit('tagsView/DEL_VIEW', tag)
      if (this.isActive(tag)) {
        const last = this.visitedViews[this.visitedViews.length - 1]
        this.safePush(last ? last.path : '/dashboard')
      }
    },
    onCommand(cmd) {
      if (cmd === 'refresh') {
        this.$parent.refresh && this.$parent.refresh()
      } else if (cmd === 'others') {
        this.$store.commit('tagsView/DEL_OTHERS', this.$route)
      } else if (cmd === 'all') {
        this.$store.commit('tagsView/DEL_ALL')
        this.safePush('/dashboard')
      }
    }
  }
}
</script>

<style scoped>
.tags-view {
  background: #fff;
  padding: 8px 12px;
  border-bottom: 1px solid #e8edf5;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.tag-item { cursor: pointer; }
.more { margin-left: auto; }
</style>
